import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  tableHeader: {
    fontWeight: 600,
  },
});
